import api, { handleApiError, fetchAllDataRest } from './client';

export const groupService = {
  getGroups: async (params = {}) => {
    try {
      const queryParams = {
        search: params.search || undefined,
        courseId: params.courseId || undefined,
        academicYear: params.academicYear || undefined,
        includeArchived: params.includeArchived ?? false,
        page: params.page || 1,
        limit: params.limit || 20,
      };

      if (params.exportAll) {
        return await fetchAllDataRest('/api/groups', queryParams, 'gruppi');
      }

      const response = await api.get('/api/groups', { params: queryParams });
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get groups error:', error);
      return handleApiError(error, 'Errore nel caricamento dei gruppi');
    }
  },

  getGroup: async (id) => {
    try {
      const response = await api.get(`/api/groups/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Get group error:', error);
      return handleApiError(error, 'Errore nel caricamento del gruppo');
    }
  },

  createGroup: async (groupData) => {
    try {
      const payload = {
        name: groupData.name,
        courseId: groupData.courseId,
        description: groupData.description || null,
        maxParticipants: groupData.maxParticipants || null,
      };

      const response = await api.post('/api/groups', payload);
      return {
        success: true,
        data: response.data,
        message: 'Gruppo creato con successo',
      };
    } catch (error) {
      console.error('Create group error:', error);
      return handleApiError(error, 'Errore nella creazione del gruppo');
    }
  },

  updateGroup: async (groupData) => {
    try {
      const payload = {
        name: groupData.name,
        description: groupData.description || null,
        maxParticipants: groupData.maxParticipants || null,
      };

      const response = await api.put(`/api/groups/${groupData.id}`, payload);
      return {
        success: true,
        data: response.data,
        message: 'Gruppo aggiornato con successo',
      };
    } catch (error) {
      console.error('Update group error:', error);
      return handleApiError(error, "Errore nell'aggiornamento del gruppo");
    }
  },

  deleteGroup: async (id) => {
    try {
      await api.delete(`/api/groups/${id}`);
      return { success: true, message: 'Gruppo eliminato con successo' };
    } catch (error) {
      console.error('Delete group error:', error);
      return handleApiError(error, "Errore nell'eliminazione del gruppo");
    }
  },
};

export default groupService;
